import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { type SearchEntry } from '@/mocks/search';

export interface ResultGroup {
  category: string;
  items: SearchEntry[];
}

export default function ResultGroups({ groups }: { groups: ResultGroup[] }) {
  return (
    <div className="space-y-12">
      {groups.map((group) => (
        <section key={group.category}>
          <div className="flex items-center gap-3 mb-5">
            <span className="w-1.5 h-5 rounded-full bg-accent-500"></span>
            <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950">
              {group.category}
            </h2>
            <span className="text-xs text-foreground-500">{group.items.length} 条</span>
          </div>
          <Reveal>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              {group.items.map((item) => (
                <Link
                  key={`${group.category}-${item.title}-${item.href}`}
                  to={item.href}
                  className="group flex flex-col p-5 rounded-lg bg-background-100 border border-background-200 cursor-pointer transition-colors hover:border-primary-300 hover:bg-background-50"
                >
                  <div className="flex items-start justify-between gap-3">
                    <span className="font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </span>
                    <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-arrow-right-up-line text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
                    </div>
                  </div>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  <span className="mt-3 self-start text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 whitespace-nowrap">
                    {item.category}
                  </span>
                </Link>
              ))}
            </div>
          </Reveal>
        </section>
      ))}
    </div>
  );
}